// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productCustomizationBar-button {
  background: #fff;
  position: absolute;
  bottom: 25px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 25px;
  cursor: pointer;
}

.productCustomizationBar {
  position: absolute;
  top: 0;
  z-index: 99;
  width: 355px;
  right: -400px;
  height: calc(100vh - 53px);
  border-left: 2px solid;
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(5px);
  transition: all 1s ease-in;
}
.productCustomizationBar.active {
  right: 0px;
}
.productCustomizationBar .close {
  color: rgb(58, 58, 58);
  width: 20px;
  margin: 10px 0 10px calc(95% - 20px);
  cursor: pointer;
}
.productCustomizationBar ul.menu-header {
  justify-content: flex-start;
  border-bottom: 1px solid rgb(58, 58, 58);
}
.productCustomizationBar ul.menu-header li {
  font-size: 1vw;
  font-weight: 500;
  line-height: 1.3vw;
  color: rgb(58, 58, 58);
  padding: 0.5vw;
  margin: 0 1vw;
  position: relative;
  cursor: pointer;
}
.productCustomizationBar ul.menu-header li.active::after {
  content: "";
  width: calc(100% - 1vw);
  height: 1px;
  position: absolute;
  background-color: rgb(58, 58, 58);
  bottom: 0px;
  right: 50%;
  transform: translateX(50%);
}
.productCustomizationBar .productContainer {
  height: 60vh;
  overflow-y: scroll;
}
.productCustomizationBar .productContainer .product-box {
  margin: 15px 0;
  display: flex;
  justify-content: flex-start;
  gap: 10%;
}
.productCustomizationBar .productContainer .product-box .product-detail {
  width: 100%;
  max-width: 100px;
}
.productCustomizationBar .productContainer .product-box .product-detail img {
  width: 75px;
  height: 75px;
  object-fit: cover;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}
.productCustomizationBar .productContainer .product-box .product-detail p {
  font-weight: 400;
  color: rgb(238, 58, 36);
  font-size: 0.9vw;
  line-height: 1.2vw;
  margin: 5px 0;
}
.productCustomizationBar .productContainer .product-box .product-detail p:last-child {
  color: rgb(58, 58, 58);
  margin: 0;
}
.productCustomizationBar .productContainer .product-box .product-location {
  margin-top: 16px;
}
.productCustomizationBar .productContainer .product-box .product-location p {
  color: rgb(58, 58, 58);
  font-size: 0.75vw;
  margin-bottom: 0.4vw;
  font-weight: 400;
  line-height: 1vw;
}
.productCustomizationBar .productContainer .product-box .product-location select {
  background: transparent;
  font-size: 0.8vw;
  font-weight: 400;
  line-height: 0.8vw;
  padding: 0.4vw 0vw;
  color: rgb(97, 97, 97);
}
.productCustomizationBar .buttons {
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
}
.productCustomizationBar .buttons button {
  background-color: #ee3a24;
  border-radius: 4px;
  min-height: 25px;
  min-width: 100px;
  padding: 6px 10px;
  text-align: center;
  border: 1px solid #ee3a24;
  color: #fff;
  outline: none;
  width: 50%;
  cursor: pointer;
  line-height: 25px;
}
.productCustomizationBar .buttons button:last-child {
  background-color: transparent;
  color: #ee3a24;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.productCustomizationBar .buttons button:last-child svg {
  width: 0.7em;
}`, "",{"version":3,"sources":["webpack://./src/style/components/three/ProductCustomizationBar.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AACF;;AACA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,6GAAA;EAKA,0CAAA;EACA,0BAAA;EACA,0BAAA;AAFF;AAGE;EACE,UAAA;AADJ;AAGE;EACE,sBAAA;EACA,WAAA;EACA,oCAAA;EACA,eAAA;AADJ;AAGE;EACE,2BAAA;EACA,wCAAA;AADJ;AAEI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAAN;AACM;EACE,WAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;EACA,UAAA;EACA,0BAAA;AACR;AAGE;EACE,YAAA;EACA,kBAAA;AADJ;AAEI;EACE,cAAA;EACA,aAAA;EACA,2BAAA;EACA,QAAA;AAAN;AACM;EACE,WAAA;EACA,gBAAA;AACR;AAAQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,+CAAA;EACA,kBAAA;AAEV;AAAQ;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAEV;AADU;EACE,sBAAA;EACA,SAAA;AAGZ;AACM;EACE,gBAAA;AACR;AAAQ;EACE,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;AAEV;AAAQ;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAEV;AAGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AADJ;AAEI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAAN;AACM;EACE,6BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AACR;AAAQ;EACE,YAAA;AAEV","sourcesContent":[".productCustomizationBar-button {\n  background: #fff;\n  position: absolute;\n  bottom: 25px;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 25px;\n  cursor: pointer;\n}\n.productCustomizationBar {\n  position: absolute;\n  top: 0;\n  z-index: 99;\n  width: 355px;\n  right: -400px;\n  height: calc(100vh - 53px);\n  border-left: 2px solid;\n  border-image-source: linear-gradient(\n    169.15deg,\n    rgba(255, 255, 255, 0.4) 0%,\n    rgba(238, 237, 237, 0.2) 96.79%\n  );\n  background-color: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(5px);\n  transition: all 1s ease-in;\n  &.active {\n    right: 0px;\n  }\n  .close {\n    color: rgb(58, 58, 58);\n    width: 20px;\n    margin: 10px 0 10px calc(95% - 20px);\n    cursor: pointer;\n  }\n  ul.menu-header {\n    justify-content: flex-start;\n    border-bottom: 1px solid rgba(58, 58, 58, 1);\n    li {\n      font-size: 1vw;\n      font-weight: 500;\n      line-height: 1.3vw;\n      color: rgb(58, 58, 58);\n      padding: 0.5vw;\n      margin: 0 1vw;\n      position: relative;\n      cursor: pointer;\n      &.active::after {\n        content: \"\";\n        width: calc(100% - 1vw);\n        height: 1px;\n        position: absolute;\n        background-color: rgba(58, 58, 58, 1);\n        bottom: 0px;\n        right: 50%;\n        transform: translateX(50%);\n      }\n    }\n  }\n  .productContainer {\n    height: 60vh;\n    overflow-y: scroll;\n    .product-box {\n      margin: 15px 0;\n      display: flex;\n      justify-content: flex-start;\n      gap: 10%;\n      .product-detail {\n        width: 100%;\n        max-width: 100px;\n        img {\n          width: 75px;\n          height: 75px;\n          object-fit: cover;\n          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n          border-radius: 5px;\n        }\n        p {\n          font-weight: 400;\n          color: rgba(238, 58, 36, 1);\n          font-size: 0.9vw;\n          line-height: 1.2vw;\n          margin: 5px 0;\n          &:last-child {\n            color: rgba(58, 58, 58, 1);\n            margin: 0;\n          }\n        }\n      }\n      .product-location{\n        margin-top:16px;\n        p{\n          color: rgba(58, 58, 58, 1);\n          font-size: .75vw;\n          margin-bottom: .4vw;\n          font-weight: 400;\n          line-height: 1vw;\n        }\n        select{\n          background: transparent;\n          font-size: .8vw;\n          font-weight: 400;\n          line-height: .8vw;\n          padding: 0.4vw 0vw;\n          color: rgba(97, 97, 97, 1);\n        }\n      }\n    }\n  }\n  .buttons {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n    gap: 10px;\n    button {\n      background-color: #ee3a24;\n      border-radius: 4px;\n      min-height: 25px;\n      min-width: 100px;\n      padding: 6px 10px;\n      text-align: center;\n      border: 1px solid #ee3a24;\n      color: #fff;\n      outline: none;\n      width: 50%;\n      cursor: pointer;\n      line-height: 25px;\n      &:last-child {\n        background-color: transparent;\n        color: #ee3a24;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 5px;\n        svg {\n          width: 0.7em;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
